export class BackgroundAnimation extends Phaser.GameObjects.Container {
  private bgScene;
  private screenWidth;
  private screenHeight;

  constructor(scene, screenWidth, screenHeight) {
    super(scene);

    this.bgScene = scene;
    this.screenWidth = screenWidth;
    this.screenHeight = screenHeight;
  }

  public start = () => {
    const bgFrames = [];
    for (let i = 0; i < 293; i++) {
      // @ts-ignore
      bgFrames.push({ key: 'background_' + i });
    }

    this.bgScene.anims.create({
      key: 'animate',
      frames: bgFrames,
      frameRate: 20,
      repeat: -1
    });

    const bgAnim = this.bgScene.add.sprite(this.screenWidth * 0.5, this.screenHeight * 0.5, 'background_0');
    bgAnim.play('animate');
    bgAnim.setDepth(0);
  };

  public pause = () => {
    this.bgScene.anims.pauseAll();
  };

  public resume = () => {
    this.bgScene.anims.resumeAll();
  };
}
